export const selectPropertyPath = (slug, routePaths) => `/${routePaths.ROUTE_BASE_PROPERTY}/${slug}/`;
export const selectTarget = (openLinkInNewTab) => openLinkInNewTab ? '_blank': '_self';
